


import follow from '@/components/message/follow.vue';
import like from '@/components/message/like.vue';
import me from '@/components/message/me.vue';
import other from '@/components/message/other.vue';
import reply from '@/components/message/reply.vue';
export default {
    components: { follow, like, me, other, reply },
    name: 'index',
    middleware: 'userAuth',//中间件页面登录鉴权
    data() {
        return {
            isShow: 'like',
            mobileDetail: false, // 手机端是否已进入二级详情
        };
    },
    computed: {
        messageInfo() {
            return Array.isArray(this.$store.state.messageInfo) ? this.$store.state.messageInfo : []
        },
        /** Other 未读：站内信 + 活动 + 积分 */
        otherUnread() {
            return (Number(this.messageInfo[5]) || 0) + (Number(this.messageInfo[3]) || 0) + (Number(this.messageInfo[6]) || 0)
        },
        categoryTitle() {
            const keys = {
                like: 'page.LIKE_2',
                follow: 'page.FOLLOWERS',
                me: 'page.ME',
                reply: 'page.REPLY_TO',
                other: 'page.OTHER',
            }
            return this.$t(keys[this.isShow] || 'page.MESSAGE')
        },
    },
    watch: {
        '$route.query.type'() {
            this.syncMobileViewFromRoute()
        },
    },
    mounted() {
        this.syncMobileViewFromRoute()
    },
    methods: {
        async readInfo(id) {
            //全部已读
            let res = await this.$global.updateNotice({ id: 0 })
            res.code == 200 ? this.getMessageInfo() : ''

        },
        async getMessageInfo(pageNo = 1) {
            //获取消息数量
            this.loading = true
            let res = await this.$global.messageLike({ page: pageNo })
            if (res.code == 200) {
                let messageInfo = []
                for (let key in res.data.get_message) {
                    messageInfo.push(res.data.get_message[key])
                }
                this.$store.commit('MESSAGEINFO', messageInfo)
            }
        },
        /** 是否为手机端视口（主断点 768） */
        isMobileViewport() {
            return process.client && window.innerWidth <= 768
        },
        /** 选中消息分类；手机端进入二级详情 */
        selectCategory(type) {
            this.isShow = type
            if (!this.isMobileViewport()) return
            this.mobileDetail = true
            if (this.$route.query.type !== type) {
                this.$router.push({ query: { type } })
            }
        },
        /** 手机端返回一级分类列表 */
        backToList() {
            this.mobileDetail = false
            if (this.$route.query.type) {
                this.$router.replace({ path: this.$route.path })
            }
        },
        /** 根据路由恢复手机端一级/二级 */
        syncMobileViewFromRoute() {
            const type = this.$route.query.type
            const valid = ['like', 'follow', 'me', 'reply', 'other']
            if (valid.includes(type)) {
                this.isShow = type
                this.mobileDetail = this.isMobileViewport()
                return
            }
            this.mobileDetail = false
        },

    }


}
